import type { ReactNode } from "react";

import { cn } from "~/lib/utils";

export function AppShell(props: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        "flex h-dvh min-h-0 w-full flex-col overflow-hidden bg-background text-foreground",
        props.className,
      )}
      data-slot="app-shell"
    >
      {props.children}
    </div>
  );
}
